const DEFAULT_PRODUCT_APP_URL = "https://app.immovox.fr";

const ATTRIBUTION_KEYS = [
  "utm_source",
  "utm_medium",
  "utm_campaign",
  "utm_term",
  "utm_content",
  "gclid",
  "gbraid",
  "wbraid",
  "msclkid",
  "fbclid",
  "ref",
  "partner",
  "ad_account_id",
] as const;

export const PRODUCT_APP_URL = (
  import.meta.env.VITE_PRODUCT_APP_URL || DEFAULT_PRODUCT_APP_URL
).replace(/\/+$/, "");

function appendAttribution(
  url: URL,
  params: Record<string, string | undefined> = {},
): URL {
  if (typeof window !== "undefined") {
    const current = new URLSearchParams(window.location.search);
    for (const key of ATTRIBUTION_KEYS) {
      const value = current.get(key);
      if (value) url.searchParams.set(key, value);
    }
  }

  for (const [key, value] of Object.entries(params)) {
    if (value) url.searchParams.set(key, value);
  }

  return url;
}

export function productAppUrl(
  path: string,
  params: Record<string, string | undefined> = {},
): string {
  return appendAttribution(
    new URL(path, `${PRODUCT_APP_URL}/`),
    params,
  ).toString();
}

export function signupUrl(plan?: string): string {
  return productAppUrl("/demarrer/besoin", plan ? { plan } : {});
}

export function loginUrl(): string {
  return productAppUrl("/auth");
}
